module.exports = __webpack_public_path__ + "img/figure0-offer2.28bb4093.png";